import { Stack, Box, Typography, Button } from '@mui/material';
import ResumenInventario from './ResumenInventario';
import InventarioFiltersBar from './components/InventarioFiltersBar';
import ImportarExcelSimple from '../shared/ImportarExcelSimple';

export default function Dashboard({ state, filters, onFiltersChange }) {
  return (
    <Stack spacing={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
        <Typography variant="h5">Inventario valorizado</Typography>
        <Button variant="outlined" onClick={() => {
          const n = prompt('Nombre del producto:');
          if (n) state.agregarProducto(n);
        }}>
          + Nuevo Producto
        </Button>
      </Box>

      <ImportarExcelSimple
        headers={["nombre"]}
        filaEjemplo={["Acero"]}
        filename="plantilla-productos-inventario.xlsx"
        titulo="Importar productos (Excel)"
        ayuda="Una columna: nombre. Duplicados se omiten."
        onFilas={(filas) => state.agregarProductosMasivo(filas.map((f) => f.nombre))}
      />

      <InventarioFiltersBar
        filters={filters}
        onChange={onFiltersChange}
        productos={state.productos}
        movimientos={state.movimientos}
        metodo={state.metodo}
        exportDataset="stock"
        mode="stock"
        title="Filtros"
      />

      <ResumenInventario
        productos={state.productos}
        calcularStock={state.calcularStock}
        obtenerValorInventario={state.obtenerValorInventario}
        productId={filters.productId}
        metodo={state.metodo}
      />
    </Stack>
  );
}
